<div class="viewer" role="dialog" aria-modal="true">
  <div class="viewer-top">
    <span class="viewer-count" *ngIf="hasMany">{{ index + 1 }} / {{ images.length }}</span>
    <button type="button" class="viewer-btn viewer-close" (click)="close()" aria-label="Close">
      <svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.6" stroke-linecap="round" aria-hidden="true">
        <path d="M6 6l12 12M18 6L6 18" />
      </svg>
    </button>
  </div>

  <div #stage class="viewer-stage"
    (click)="onBackdropClick($event)"
    (touchstart)="onTouchStart($event)"
    (touchmove)="onTouchMove($event)"
    (touchend)="onTouchEnd($event)"
    (touchcancel)="onTouchEnd($event)"
    (wheel)="onWheel($event)">
    <img #img *ngIf="current" [src]="current" alt="" class="viewer-img"
      [class.animating]="animating"
      [style.transform]="transform"
      (dblclick)="onDoubleClick($event)"
      draggable="false" />
  </div>

  <button *ngIf="hasMany && index > 0" type="button" class="viewer-btn viewer-nav viewer-prev"
    (click)="prev()" aria-label="Previous">
    <img src="icons/arrow_back_white.svg" alt="" />
  </button>
  <button *ngIf="hasMany && index < images.length - 1" type="button" class="viewer-btn viewer-nav viewer-next"
    (click)="next()" aria-label="Next">
    <img src="icons/arrow_back_white.svg" alt="" class="flip" />
  </button>

  <p class="viewer-hint" *ngIf="scale === 1">
    {{ lang === 'TH' ? 'แตะสองครั้งหรือถ่างนิ้วเพื่อขยาย' : 'Double-tap or pinch to zoom' }}
  </p>
</div>
